import React from 'react';
import { Link } from 'react-router-dom';
import { useRunRouteLoader } from '../hooks/useRunRouteLoader';

/**
 * This component can be used to prefetch route data when the link is rendered.
 *
 * This component wraps React Router's Link and automatically triggers a `fetcher.load()`
 * call when the component mounts. This calls the route's `loader` function.
 *
 * **IMPORTANT**: For prefetching to work, the target route MUST have a loader function
 * defined that contains the data fetching logic.
 * Otherwise, this will have no effect.
 *
 * https://reactrouter.com/start/data/data-loading
 *
 * @param props - All props are passed to react-router-dom's `Link` component
 * @returns A `Link` component with prefetching behavior
 */
// eslint-disable-next-line react/display-name -- lint-backlog: anonymous forwardRef/memo component; add a displayName in a follow-up
export const PrefetchingLink = React.forwardRef<
  HTMLAnchorElement,
  React.ComponentProps<typeof Link>
>((props, ref) => {
  useRunRouteLoader(props.to);

  return <Link ref={ref} {...props} />;
});
